
export default {
	gender: 'ваш пол',
	age: 'ваш возраст',
	place: 'место прогулки',
	time: 'время прогулки',

	old: 'возраст',
	body: 'телосложение',
	size: 'размер',

	city: 'ваш город', 
}



// WEBPACK FOOTER //
// ./src/data/locale.js